import React from 'react';
import { IEditorProps } from '../Editor';
import { EditorEntityPicker } from './EditorEntityPicker';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { EntityTypeInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder/EntityTypeInfo';
import { Label } from 'components/inputs/Label';
import { getPropertyDisplayLabel } from 'components/property-editors/utils/ProviderNodeUtils';
interface IFolderPickerEditorProps extends IEditorProps {}

export function FolderPickerEditor(props: IFolderPickerEditorProps) {
  const entityTypeInfo: EntityTypeInfo[] = getEditorConfigValue(props.child, 'EntityTypesInfo');

  const isValid =
    entityTypeInfo.filter(info => info.EntityTypeName !== 'DecisionsFramework.ServiceLayer.Services.Folder.Folder')
      .length === 0;

  return isValid ? (
    <EditorEntityPicker {...props} />
  ) : (
    <Label label={getPropertyDisplayLabel(props.child)}>Only Folder type is allowed for Folder Picker</Label>
  );
}
